<template>
  <q-page class="q-pa-md bg-grey-2 row items-center justify-center">
    <q-card style="width: 500px; max-width: 95vw;" class="shadow-4 rounded-borders">
      <q-card-section class="bg-primary text-white text-center q-py-md">
        <div class="text-h6 text-weight-bold">Registro de Usuario</div>
        <div class="text-caption text-blue-2">Cree una cuenta para acceder a la plataforma</div>
      </q-card-section>

      <q-card-section class="q-pa-md">
        <q-form @submit.prevent="registrar" class="q-gutter-y-md">
          <q-input
            v-model="userdata.nombres"
            label="Nombres *"
            outlined
            dense
            :rules="[val => !!val || 'Nombres requeridos']"
          />

          <q-input
            v-model="userdata.apellidos"
            label="Apellidos *"
            outlined
            dense
            :rules="[val => !!val || 'Apellidos requeridos']"
          />

          <q-input
            v-model="userdata.email"
            label="Correo Electrónico *"
            type="email"
            outlined
            dense
            :rules="[
              val => !!val || 'Email es requerido',
              val => /.+@.+\..+/.test(val) || 'Email no válido'
            ]"
          />

          <q-input
            v-model="userdata.pwd"
            label="Contraseña *"
            type="password"
            outlined
            dense
            :rules="[val => !!val || 'Contraseña requerida', val => val.length >= 6 || 'Mínimo 6 caracteres']"
          />

          <q-input
            v-model="passwordRepeat"
            label="Repetir Contraseña *"
            type="password"
            outlined
            dense
            :rules="[
              val => !!val || 'Confirme la contraseña',
              val => val === userdata.pwd || 'Las contraseñas no coinciden'
            ]"
          />

          <div class="row justify-between items-center q-pt-sm">
            <q-btn label="Volver a Login" flat color="grey-8" to="/login" />
            <q-btn
              label="Registrar"
              type="submit"
              color="primary"
              unelevated
              :loading="mostrarSpinner"
              class="text-weight-bold"
            />
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </q-page>
</template>

<script>
import axios from "axios";

export default {
  name: "RegistroPage",
  data() {
    return {
      mostrarSpinner: false,
      passwordRepeat: "",
      userdata: {
        nombres: "",
        apellidos: "",
        email: "",
        pwd: "",
      },
    };
  },
  methods: {
    registrar() {
      if (this.userdata.pwd !== this.passwordRepeat) {
        this.notificar("Las contraseñas no coinciden", "negative");
        return;
      }
      this.mostrarSpinner = true;
      let me = this;
      axios.post("ApiWeb/UsuarioInsertar.php", this.userdata)
        .then((res) => {
          if (!res.data.error) {
            me.notificar("Registro exitoso. Inicie sesión.", "positive");
            me.$router.push("/login");
          } else {
            me.notificar(res.data.mensaje || "Error al registrar usuario", "negative");
          }
        })
        .catch((err) => {
          console.error(err);
          me.notificar("Error en el servidor al registrar", "negative");
        })
        .finally(() => {
          this.mostrarSpinner = false;
        });
    },
    notificar(msg, color) {
      if (this.$q && this.$q.notify) {
        this.$q.notify({
          message: msg,
          color: color,
          position: "top-right",
          timeout: 3000
        });
      } else {
        alert(msg);
      }
    }
  },
};
</script>
